export default __webpack_public_path__ + "static/media/revisionS.5f3bc90a.png";